import React  from 'react';
import PropTypes from 'prop-types';
import Footer from "./Main/components/Footer";
import '../../assets/stylesheets/Layouts/Main.scss'

const OnlyFooter = props => {
  const { children } = props;
  return (
      <div className={`mainLayout`}>
        <main className={`pageContent`} >
          {children}
        </main>
        <Footer />
      </div>
  );
};

OnlyFooter.propTypes = {
  children: PropTypes.node
};

export default OnlyFooter;
